import { atom } from "recoil";

export const dateRangeForDatagridTable = atom<[string, string] | undefined>({
  key: "dateRangeForDatagridTable",
  default: undefined,
});
